var cancel_membership_form = (function( $ ) {

	var $form;

	var $gform_submit_button;

	var _init = function() {
		$form = $( '#gform_28' );

		if ( $form.length > 0 ) {
			_setup_confirmation_button();
		}
	};

	var _setup_confirmation_button = function() {
		var $gform_footer        = $form.find( '.gform_footer' );
		$gform_submit_button = $gform_footer.find( '#gform_submit_button_28' );
		var submit_button        = '<a href="#" class="confirm-submission button">Request cancellation</a>';

		$gform_submit_button.hide();
		$gform_footer.prepend( submit_button );

		$gform_footer.find( '.confirm-submission' ).on( 'click', _confirm_submission );
	};

	var _confirm_submission = function( e ) {
		e.preventDefault();

		var cancel = confirm( 'Are you sure you want to cancel your membership?' );

		if ( cancel ) {
			$gform_submit_button.trigger( 'click' );
		}
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = cancel_membership_form;